<template>
  <v-container class="container-custom">
    <v-card class="pa-6 text-center" elevation="6" max-width="500">
      <v-card-title class="text-h5 font-weight-bold justify-center">Sistema de Gestión</v-card-title>

      <!-- Botones de navegación -->
      <v-btn v-if="['admin', 'adminTI', 'adminSIST'].includes(usuario?.rol)" color="light-blue" class="mb-4" block
        @click="$router.push('/clients')">
        Clientes
      </v-btn>

      <v-btn v-if="['admin', 'adminTI', 'adminSIST', 'lector'].includes(usuario?.rol)" color="light-blue" class="mb-4"
        block @click="$router.push('/gabinetes')">
        Sistemas
      </v-btn>

      <v-btn v-if="['admin', 'adminTI', 'adminSIST'].includes(usuario?.rol)" color="light-blue" class="mb-4" block
        @click="$router.push('/gestion-entidades')">
        Gestion Sistemas
      </v-btn>

      <v-btn v-if="['admin', 'adminTI', 'adminSIST', 'lector', 'visualizador'].includes(usuario?.rol)"
        color="light-blue" class="mb-4" block @click="$router.push('/Dashboards')">
        Dashboards
      </v-btn>

      <v-btn v-if="['admin', 'adminTI'].includes(usuario?.rol)" color="light-blue" class="mb-4" block
        @click="$router.push('/Logs')">
        Logs
      </v-btn>


    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      usuario: JSON.parse(sessionStorage.getItem("usuario"))
    };
  },
  methods: {
    created() {
      const user = sessionStorage.getItem("usuario");
      console.log("🧾 Usuario cargado:", user);
    },
    cerrarSesion() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("usuario");
      this.usuario = null;

      this.$router.push("/");
    },


  }
};
</script>

<style scoped>
/* Contenedor centrado */
.container-custom {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
